module.exports = __webpack_public_path__ + "static/media/login-bg-3.2ebe639b.jpg";